import React, { Component, useEffect } from "react";
import * as stdActions from "../../redux/actions/stdAction";
import { useDispatch, useSelector } from "react-redux";
import { bindActionCreators } from "redux";
import PropTypes from "prop-types";
import Sidebar from "../../components/Sidebar";
import { setLanguage } from "redux-i18n";
import * as modalActions from "../../redux/actions/modalActions";
import * as commonActions from "../../redux/actions/commonAction";
import * as attachmentsActions from "../../redux/actions/attachmentsAction";
import AttachmentsComponent from "../../components/Attachments";
import {
  caseStatusInitialPagination,
  ersInitialPagination,
} from "../../App.config";
import { useLocation } from "react-router-dom";
import history from "../../utilities/history";
// import CaseStatusComponent from "../../components/CaseStatus";
import * as accomodationActions from "../../redux/actions/accomodationAction";
import AccomodationCaseStatustemplete from "../../components/AcmdCasestatus";

const AccomodationCaseStatus = (props, context) => {

  const profileReducer = useSelector((state) => state.profileReducer);
  const commonReducer = useSelector((state) => state.commonReducer);
  const i18nReducer = useSelector((state) => state.i18nState);
  const attachmentsReducer = useSelector((state) => state.attachmentsReducer);
  const accomodationreducer = useSelector(
    (state) => state.accomodationReducer
  );

  const dispatch = useDispatch();
  let accomodationAction = bindActionCreators(accomodationActions, dispatch);
  const modalAction = bindActionCreators(modalActions, dispatch);
  const commonAction = bindActionCreators(commonActions, dispatch);
  const attachmentsAction = bindActionCreators(attachmentsActions, dispatch);
  // const managerApplicantAction = bindActionCreators(
  //   managerApplicantActions,
  //   dispatch
  // );

  //Set initial pagination and call api after first render
  useEffect(() => {
    accomodationAction.setCurrentPage(
      caseStatusInitialPagination.pageNo
    );
    accomodationAction.setPageSize(
      caseStatusInitialPagination.pageSize
    );
    accomodationAction.getCaseStatus(null, caseStatusInitialPagination);
  }, []);

  const languageChange = (language) => {
    dispatch(setLanguage(language));
  };
  const onMenuToggle = (isOpen) => {
    commonAction.setIsSideMenuOpen(isOpen);
  };

  const openSetModal = (children) => {
    modalAction.openSetModal(children);
  };

  const closeRemoveModal = () => {
    modalAction.closeRemoveModal();
  };

  const onPageSizeChange = (pageSize) => {
    accomodationAction.getCaseStatus(null, {
      pageNo: accomodationreducer.currentPage,
      pageSize: pageSize,
      totalRows: accomodationreducer.totalRows,
    });
    accomodationAction.setPageSize(pageSize);
  };

  const onChange = (page) => {
    accomodationAction.setCurrentPage(page.value);
    accomodationAction.getCaseStatus(null, {
      pageNo: page.value,
      pageSize: accomodationreducer.currentPage,
      totalRows: accomodationreducer.totalRows,
    });
  };

  //  const setCaseStatusModified = (modifiedCaseStatus) => {
  //    accomodationAction.setCaseStatusModified(modifiedCaseStatus);
  //  };

  const getSearchCaseStatus = (searchKey) => {
    accomodationAction.getCaseStatus(
      searchKey,
      caseStatusInitialPagination
    );
  };
  return (
    <>
      <AccomodationCaseStatustemplete
        caseStatusDetails={accomodationreducer.caseStatus}
        //setCaseStatusModified={setCaseStatusModified}
        onPageSizeChange={onPageSizeChange}
        getSearchCaseStatus={getSearchCaseStatus}
        isCustomAttachment={attachmentsReducer.isCustomAttachment}
        attachmentData={attachmentsReducer.attachments}
        currentPage={accomodationreducer.currentPage}
        pageSize={accomodationreducer.pageSize}
        totalRows={accomodationreducer.totalRows}
        onChange={(props) => {
          onChange(props);
        }}
        context={context}
      />
    </>
  );
};

export default AccomodationCaseStatus;
